function Footer () {
  return (
    <footer className='mastfoot mt-auto'>
      <div className='inner '>
        <p>Copyright &copy; 2018 - 2020<br />
          <a href='//lukasmatuska.cz' target='_blank' rel='noopener noreferrer'>Lukáš&nbsp;Matuška</a>
          &nbsp;pro&nbsp;
          <a href='//rudickamladez.cz' target='_blank' rel='noopener noreferrer'>Rudickou&nbsp;mládež</a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
